import React from 'react';
import { Skeleton } from 'site-modules/shared/components/skeleton/skeleton';

import './learn-more-skeleton.scss';

export const LearnMoreSkeleton = () => (
  <div className="learn-more-skeleton">
    <Skeleton className="d-block height-22 rounded-6 w-40 mb-1" />
    <div className="link bg-blue-100  d-flex align-items-center ps-0_5 pe-1 py-0_5">
      <Skeleton className="image d-block rounded-circle me-0_75" />
      <div className="flex-grow-1">
        <Skeleton className="d-block height-18 rounded-6 w-40 mb-0_5" />
        <Skeleton className="d-block height-18 rounded-6 w-30" />
      </div>
    </div>
  </div>
);
